import { AiRequestManager } from './AiRequest';

// 기본 인스턴스 제공
const defaultAiRequestManager = new AiRequestManager();

export { defaultAiRequestManager }; 